import BaseService from "./BaseService";

export default class FeeService extends BaseService {
    public static getGlobalLimitsByCurrency(token: string, currency: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}payment/limit/${currency}`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        })
    } 

    public static getGlobalLimitsByCurrencyv2(token: string, currency: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}payment/limit/v2/${currency}`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            }
        })
    } 
    
    public static updateGlobalLimits(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'payment/limit', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static updateGlobalLimitsV2(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'payment/limit/v2', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static deleteSelectedExistingLimits(token: string, TRANSACTION_ID: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}payment/limit/user/${TRANSACTION_ID}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
    }

    public static getUserSettings(token: string, userId: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}payment/limit/user/V1/${userId}`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
    }

    public static updateUserSettings(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'payment/limit/user/V1', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }
}